<div style="display: flex; display: -ms-flexbox; flex-direction: column; -ms-flex-direction: column; max-height: 100px;">
  <ng-container *ngIf="apiAccessible === 1">
    <div style="flex: 1; -ms-flex: 1 0 auto;">
      <!-- main menu -->
      <app-header (loginEvent)="loginRedirect()" (logoutEvent)="logout()"></app-header>
      <div class="app-layout app">
        <div *ngIf="isFacebookInAppBrowser" class="facebook-inapp-warning" style="background: #fff3cd; color: #856404; padding: 16px; border: 1px solid #ffeeba; text-align: center; z-index: 2000;">
          <strong>Notice:</strong> You are using the Facebook in-app browser, which may cause unexpected errors. For the best experience, please open this site in your device's default browser (e.g., Chrome or Safari).<br /> The easiest way to do this is to open the menu in the app and select 'Open in external browser'
        </div>
        
        <!-- page content -->
        <router-outlet></router-outlet>
      </div>
    </div>
    <sticky-button id="sticky-contact-us-button" [name]="'sticky-contact-us-button'"  [iconClass]="'fa fa-paper-plane fa-2x'" ></sticky-button>  
    <!-- footer -->
    <app-footer *ngIf="showFooter"></app-footer>
    <!-- The sticky button bar that shows for mobile apps.  It is currently only shown
    on listing details but can be shown/configured by other components (via the StickyService) in 
    future development -->
    <sticky-button-bar id="mobile-sticky-button-bar" class="not-desktop-wide"></sticky-button-bar>
    
  </ng-container>
  <!-- Email Popup Modal -->
     <ng-template #collectEmailPopup> 
      <div class="modal-body">
        <collect-email (completed)="onCollectEmailComplete()">
        </collect-email>
      </div>
     </ng-template> 
 


  <!-- When the app can't reach Outdoor Access Platform, display this:  -->
  <ng-container *ngIf="apiAccessible === 0">
    <div>
      <div class="text-center" style="margin-left:15px;margin-right:15px;">
        <h2>Can not connect to the Outdoor Access server.</h2>
        <div class="container">
          <div class="row text-center row-fluid">
            <div class="col-12">
              <div class="panel panel-default">
                <!-- <div class="panel-heading">Panel 1</div> -->
                <div class="panel-body">
                  <div class="text-center">
                    <div class="text-left">
                      <h4>Connection loss can be caused by any of the following:</h4>

                      <ul>
                        <li>
                          This device has lost network connectivity.
                        </li>

                        <li>
                          A network disruption between the network this device is connected to and the network hosting Outdoor Access
                          servers.
                        </li>

                        <li>
                          The Outdoor Access servers are down or in an error status.
                        </li>
                      </ul>
                    </div>

                    <div class="text-left">
                      <h4>Next Steps?</h4>

                      <ul>
                        <li>
                          Wait a couple of minutes and reload this page to see if the issue is resolved.
                        </li>

                        <li>
                          Contact <a href="mailto:support@outdooraccess.com">support&#64;outdooraccess.com</a> Outdoor Access Support can help
                          determine if your issue is shared with others on the platform or only experienced by you.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  
</div>


